export enum InspectionType {
  Incoming = 'Incoming',
  Periodic = 'Periodic',
  Inline = 'Inline',
}
